export const REQUIRED_FIELD = 'Field is required';
export const BOOLEAN_REQUIRED_FIELD = 'Checkbox must be checked';
